<script lang="ts">
    import { content, language, openedElements } from "../../../store"
    import changeOpenedElement from "../../functions/changeOpenElement"
    import SubField from "./subField.svelte"
    import Person from "./Person.svelte"
    export let row
    export let i: number
    let rebuild = false
    let contentContainer = false
    let opened = false

    $: {
        if (!opened) {
            rebuild = !rebuild
        }
        opened = contentContainer == $openedElements.mainPoint
    }

    let options = {}
</script>

<div class="row">
    <div class="container">
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
            class="title-row"
            id="trowNr-{i}"
            on:click="{(e) => {
                console.log('test')
                $openedElements = changeOpenedElement(contentContainer, 'mainPoint')
            }}"
        >
            <div class="max-width-container">
                <button class="plus opener" class:main-opened="{opened}"
                    ><img src="/media/plus.svg" alt="plus" /></button
                >
                <h2 class="title">{row[0]}</h2>
            </div>
        </div>
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <div
            class="{`subFields collapsible-wrapper  ${opened ? 'showContent' : 'collapsed'}`}"
            bind:this="{contentContainer}"
            id="rowNr-{i}"
            on:click="{(e) => {
                console.log('test2')
            }}"
        >
            <div class="collapsible">
                {#key rebuild}
                    {#each row[1][1] as subPoint, si}
                        {#if subPoint.contentType == "persons"}
                            <div class="container">
                                <div class="persons">
                                    <div class="line"></div>
                                    <Person
                                        i="{si}"
                                        rowI="{i}"
                                        subPoint="{subPoint}"
                                        on:unselect="{(e) => (options = {})}"
                                        on:select="{(e) => {
                                            let person = e.detail.person
                                            options =
                                                $language == 'german'
                                                    ? {
                                                          VITA: person.vita,
                                                          ERFAHRUNGSSPEKTRUM: person.experience,
                                                          LEISTUNGSSCHWERPUNKTE: person.performance,
                                                      }
                                                    : {
                                                          CV: person.vita,
                                                          'RANGE OF EXPERIENCE': person.experience,
                                                          'KEY PERFORMANCE AREAS': person.performance,
                                                      }
                                        }}"
                                    />
                                </div>
                                <div class="full-width">
                                    {#if Object.values(options).length != 0}
                                        {#each Object.entries(options) as entry, si}
                                            {#if entry[1]}
                                                <SubField
                                                    subPoint="{{ title: entry[0], content: entry[1] }}"
                                                    i="{si}"
                                                    rowI="{i}"
                                                />
                                            {/if}
                                        {/each}
                                    {/if}
                                </div>
                            </div>
                        {:else}
                            <SubField subPoint="{subPoint}" i="{si}" rowI="{i}" />
                        {/if}
                    {/each}
                {/key}
            </div>
        </div>
    </div>
</div>

<style lang="less">
    @import "../../assets/css/collapse.less";
    @import "../../assets/css/variables.less";
    .full-width {
        width: 100%;
    }
    .row {
        width: 100%;
        margin-bottom: 1px;
        display: flex;
        justify-content: center;
        .container {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;

            .subFields {
                width: 100%;
                .container {
                    display: flex;
                    justify-content: center;
                    .persons {
                        display: flex;

                        @media @mobile {
                            padding: 0px calc(@default-padding / 1.5);
                        }
                        @media @tablet {
                            padding: 0px @default-padding;
                        }
                        width: 100%;
                        max-width: @max-width;
                        .line {
                            flex-shrink: 0;
                            @media @mobile {
                                width: 40px !important;
                            }
                            @media @tablet {
                                width: 80px !important;
                            }
                            background-color: @main-bright;
                        }
                    }
                }
            }
            .hideContent {
                max-height: 0px;
            }

            .title-row {
                cursor: pointer;
                background-image: linear-gradient(to bottom, #bbbfc7 0%, rgba(91, 103, 126, 0) 100%);
                width: 100%;
                display: flex;
                justify-content: center;
                .max-width-container {
                    width: 100%;
                    max-width: @max-width;
                    width: 100%;

                    @media @mobile {
                        padding: 0px calc(@default-padding / 1.5);
                    }
                    @media @tablet {
                        padding: 0px @default-padding;
                    }
                    height: 80px;
                    gap: 40px;
                    display: flex;
                    align-items: center;

                    .plus {
                        @media @mobile {
                            width: 40px !important;
                        }
                        @media @tablet {
                            width: 80px !important;
                        }

                        flex-shrink: 0;
                        height: 80px;
                        background-color: @main-dark;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        image {
                            opacity: 1;
                        }
                    }
                    .main-opened {
                        background-color: @main-selected;
                        img {
                            opacity: 0;
                        }
                    }
                }
            }
        }
    }
</style>
